// Loads the Google Identity Services client library on demand and caches the
// load so repeated mounts don't inject the script twice. Resolves once
// `window.google.accounts.id` is available.
const GSI_SRC = 'https://accounts.google.com/gsi/client'

let loadPromise = null

export function loadGoogleGsi() {
  if (window.google?.accounts?.id) return Promise.resolve()
  if (loadPromise) return loadPromise

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${GSI_SRC}"]`)
    const script = existing ?? document.createElement('script')
    script.src = GSI_SRC
    script.async = true
    script.defer = true
    script.addEventListener('load', () => resolve())
    script.addEventListener('error', () => {
      loadPromise = null // allow a retry on the next attempt
      reject(new Error('Google Identity Services skriptini yuklab bo\'lmadi'))
    })
    if (!existing) document.head.appendChild(script)
  })
  return loadPromise
}
